<template>
  <apexchart type="line" :options="seismicChart" :series="seismicSeries" :height="height" :width="width"></apexchart>
</template>

<script>
import Vue from "vue";
import VueApexCharts from "vue-apexcharts";

Vue.component("apexchart", VueApexCharts);

export default {
  props: {
    seismicSeries: Array,
    height: Number,
    width: Number,
  },
  data() {
    return {
      seismicChart: {
        chart: {
          id: "seismic",
          group: "smp",
          type: "line",
          animations: {
            enabled: false,
          },
        },
        markers: {
          size: 0,
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          tooltip: {
            enabled: false,
          },
          type: "datetime",
          labels: {
            datetimeUTC: false,
            style: {
              fontSize: "12px",
              colors: "primary",
            },
          },
        },

        tooltip: {
          x: {
            format: "dd MMM yyyy hh:mm:ss tt",
          },
          theme: true,
        },
        legend: {
          show: true,
          showForSingleSeries: true,
          position: "bottom",
          labels: {
            colors: "primary",
          },
        },
        yaxis: {
          max: 30,
          tickAmount: 5,
          axisTicks: {
            show: true,
          },
          labels: {
            offsetX: -14,
            style: {
              fontSize: "12px",
              colors: "primary",
            },
            formatter: (val) => {
              return val.toFixed(4) + " mm/s";
            },
          },
        },
        stroke: {
          show: true,
          curve: "smooth",
          lineCap: "butt",
          colors: undefined,
          width: 2,
          dashArray: 0,
        },
      },
    };
  },
};
</script>

<style>
.apexcharts-xcrosshairs {
  stroke-linecap: round;
  stroke-width: 2px;
  stroke-dasharray: 4;
  stroke: red;
}
</style>